import { create } from "zustand";
import { getCreditPromoStatus, CreditPromoStatus } from "@/utils/api/creditPromo";

// Feature flag to enable/disable the credit promo feature
const CREDIT_PROMO_ENABLED = true;

interface CreditBannerState {
    // Feature flag
    isPromoEnabled: boolean;

    // UI state
    isBannerDismissed: boolean;

    // API state
    promoStatus: CreditPromoStatus | null;
    promoStatusLoading: boolean;
    promoStatusError: string | null;

    // Actions
    dismissBanner: () => void;
    fetchPromoStatus: (workspaceId?: string) => Promise<void>;
}

export const useCreditBannerStore = create<CreditBannerState>((set, get) => ({
    // Feature flag
    isPromoEnabled: CREDIT_PROMO_ENABLED,

    // UI state
    isBannerDismissed: false,

    // API state
    promoStatus: null,
    promoStatusLoading: false,
    promoStatusError: null,

    // Actions
    dismissBanner: () => set({ isBannerDismissed: true }),

    fetchPromoStatus: async (workspaceId?: string) => {
        // Don't fetch if feature is disabled
        if (!CREDIT_PROMO_ENABLED) return;

        // Avoid duplicate fetches
        if (get().promoStatusLoading) return;

        set({ promoStatusLoading: true, promoStatusError: null });

        try {
            const promoStatus = await getCreditPromoStatus(workspaceId);
            set({ promoStatus, promoStatusLoading: false });
        } catch (error) {
            console.error("Error fetching credit promo status:", error);
            set({
                promoStatusError:
                    error instanceof Error ? error.message : "Failed to fetch promo status",
                promoStatusLoading: false
            });
        }
    }
}));
